export default {
  code: '404',
  text: 'Stránka neexistuje',
  button: 'Jít na začátek',
};
